import { DateTime } from "luxon";
import { z } from "zod";
import { asISODateTime, isoDateTimeSchema } from "./filters.js";
const dateOnlyRegex = /^\d{4}-\d{2}-\d{2}$/;
function lenientDateBoundSchema(bound) {
  return z.string().describe(
    `Either a calendar date (YYYY-MM-DD) or a full ISO datetime with offset. A date-only value is interpreted in UTC as the ${bound === "after" ? "start" : "end"} of that day.`
  ).transform((value, ctx) => {
    if (dateOnlyRegex.test(value)) {
      const day = DateTime.fromISO(value, { zone: "utc" });
      if (!day.isValid) {
        ctx.addIssue({ code: "custom", message: `Invalid date: ${value}` });
        return z.NEVER;
      }
      const normalized = bound === "after" ? day.startOf("day") : day.endOf("day");
      const iso = normalized.toUTC().toISO();
      if (!iso) {
        ctx.addIssue({ code: "custom", message: `Invalid date: ${value}` });
        return z.NEVER;
      }
      return asISODateTime(iso);
    }
    const parsed = isoDateTimeSchema.safeParse(value);
    if (!parsed.success) {
      ctx.addIssue({
        code: "custom",
        message: `Expected YYYY-MM-DD or a full ISO datetime with offset, got: ${value}`
      });
      return z.NEVER;
    }
    return parsed.data;
  });
}
const lenientDateRangeSchema = z.object({
  after: lenientDateBoundSchema("after"),
  before: lenientDateBoundSchema("before")
});
const MAX_DAILY_TREND_RANGE_DAYS = 366;
const boundedLenientDateRangeSchema = lenientDateRangeSchema.refine(
  ({ after, before }) => DateTime.fromISO(before).diff(DateTime.fromISO(after), "days").days <= MAX_DAILY_TREND_RANGE_DAYS,
  {
    message: `date_range may span at most ${MAX_DAILY_TREND_RANGE_DAYS} days. Narrow it, or ask about consecutive windows of at most a year each.`
  }
);
export {
  MAX_DAILY_TREND_RANGE_DAYS,
  boundedLenientDateRangeSchema,
  lenientDateBoundSchema,
  lenientDateRangeSchema
};
//# sourceMappingURL=lenientDateRange.js.map
